export function getValueOrDefault(field, values) {
    if (values && values[field.qid]) {
        return values[field.qid];
    }
    if (field.field_type === 'fileInput') {
        return {
            type: 'fileInput',
            tokens: [],
        };
    }
    if ((field.field_type === 'select' || field.field_type === 'radio') &&
        field.field_options &&
        field.field_options.defaultValue) {
        return {
            type: 'textInput',
            value: field.field_options.defaultValue,
        };
    }
    return {
        type: 'textInput',
        value: '',
    };
}
export function getValuesOrDefault(form, values) {
    return form.reduce(function (acc, field) {
        acc[field.qid] = getValueOrDefault(field, values);
        return acc;
    }, {});
}
